import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { DateTime } from 'luxon';

import { formatMoney, getDate } from '../../utils/functions/Utils';

import './styles.css';

const FormatoCatalogo = (props) => {

    const [renderHoja, setRenderHoja] = useState(<></>);
    const [pages, setPages] = useState([]);

    // asigna los valores de la cotizacion a las variables de estado
    useEffect(() => {
        if (props.products) {
            let pages = getPages(props.products);
            setPages(pages);
        }
    }, [props])

    // funcion para imprimir el formato
    const printDocument = () => {
        let printContents = document.getElementById('printDiv').innerHTML;
        localStorage.setItem('printContent', JSON.stringify({ printContents: printContents, name: `Catalogo_membranas_juvalfri_${getDate(DateTime.now(), 'YY')}` }));
        window.open('/print', '_blank');
    }

    const getCatalogType = (type) => {
        switch (type) {
            case 'membranas':
                return 'catalog_tm_front.svg';
            case 'impresion':
                return 'catalog_i3d_front.svg';
            default:
                return 'Catálogo';
        }
    }

    const getPages = (products) => {
        let pages = [];
        let page = [];

        products.forEach((product, i) => {
            page.push(product);

            // Cuando completamos una página de 3 productos, la añadimos a pages
            if ((i + 1) % 3 === 0) {
                pages.push(page);
                page = [];
            }
        });

        // Si hay productos restantes en `page`, los agregamos como la última página
        if (page.length > 0) {
            pages.push(page);
        }

        return pages;
    };

    const renderPage = (items) => {
        return (
            <div style={{ width: '816px', height: '1056px', backgroundImage: `url(/${props.company}/bg-catalog.svg)`, zIndex: '-1' }} className='p-0'>
                {/* <img src={`/${props.company}/bg-catalog.svg`} alt='bg-catalog' style={{ position: 'relative', width: '100%', height: '100%', objectFit: 'cover', zIndex: '-2' }} /> */}
                <div style={{ width: '770px', borderRadius: '5px', marginLeft: '23px' }}>
                    <div style={{ height: '140px' }}></div>
                    {items[0] &&
                        <div style={{ marginBottom: '12px', height: '250px', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center', padding: '12px', background: 'linear-gradient(270deg, rgba(255,255,255,0.3) 10%, rgba(255,255,255,1) 50%)', borderRadius: '20px', border: 'solid #FFF 1px' }}>
                            <div>
                                <img src={items[0].imagen} alt={items[0].nombre} style={{ width: 'auto', maxHeight: '200px', maxWidth: '250px', height: 'auto', margin: '10px 10px' }} />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', color: '#000000', fontFamily: 'Mona Sans', maxWidth: '475px' }}>
                                <p style={{ fontWeight: 700, fontSize: '24px', padding: '0px 12px' }}>{items[0].nombre}</p>
                                <p style={{ padding: '0px 12px' }}>{items[0].descripcion}</p>
                                {/* <p style={{ padding: '0px 12px' }}>{items[0].precioDistribuidor}</p> */}
                            </div>
                        </div>
                    }
                    {items[1] &&
                        <div style={{ marginBottom: '12px', height: '250px', display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-evenly', alignItems: 'center', padding: '12px', background: 'linear-gradient(90deg, rgba(255,255,255,0.3) 10%, rgba(255,255,255,1) 50%)', borderRadius: '20px', border: 'solid #FFF 1px' }}>
                            <div>
                                <img src={items[1].imagen} alt={items[1].nombre} style={{ width: 'auto', maxHeight: '200px', maxWidth: '250px', height: 'auto', margin: '10px 10px' }} />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', color: '#000000', fontFamily: 'Mona Sans', maxWidth: '475px' }}>
                                <p style={{ fontWeight: 700, fontSize: '24px', padding: '0px 12px' }}>{items[1].nombre}</p>
                                <p style={{ padding: '0px 12px' }}>{items[1].descripcion}</p>
                                {/* <p style={{ padding: '0px 12px' }}>{items[1].precioDistribuidor}</p> */}
                            </div>
                        </div>
                    }
                    {items[2] &&
                        <div style={{ marginBottom: '12px', height: '250px', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center', padding: '12px', background: 'linear-gradient(270deg, rgba(255,255,255,0.3) 10%, rgba(255,255,255,1) 50%)', borderRadius: '20px', border: 'solid #FFF 1px' }}>
                            <div>
                                <img src={items[2].imagen} alt={items[2].nombre} style={{ width: 'auto', maxHeight: '200px', maxWidth: '250px', height: 'auto', margin: '10px 10px' }} />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', color: '#000000', fontFamily: 'Mona Sans', maxWidth: '475px' }}>
                                <p style={{ fontWeight: 700, fontSize: '24px', padding: '0px 12px' }}>{items[2].nombre}</p>
                                <p style={{ padding: '0px 12px' }}>{items[2].descripcion}</p>
                                {/* <p style={{ padding: '0px 12px' }}>{items[2].precioDistribuidor}</p> */}
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }

    useEffect(() => {
        if (props.products) {
            setRenderHoja(
                <div id='printDiv'>
                    <div style={{ width: '816px', height: '1056px', backgroundImage: `url(/${props.company}/${getCatalogType(props.catalog)})`, zIndex: '-1' }} className='p-0'></div>
                    {pages.map((page, i) => {
                        return (
                            <div key={i} >
                                {renderPage(page)}
                            </div>
                        )
                    })}
                    <div style={{ width: '816px', height: '1056px', backgroundImage: `url(/${props.company}/catalog_end.svg)`, zIndex: '-1' }} className='p-0'></div>
                </div>
            )
        }
    }, [pages])

    return (
        <div>
            <div style={{ marginTop: '10px', marginBottom: '12px' }}>
                <Button className='mx-2' variant='contained' color='secondary' onClick={printDocument} > Imprimir hoja &nbsp; <i className="fad fa-print" style={{ transform: 'scale(1.3)' }}></i></Button>
            </div >
            {renderHoja}
        </div >
    )
}

export default FormatoCatalogo;